import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import TrustSection from './components/TrustSection';
import CategoryGrid from './components/CategoryGrid';
import ComparisonSection from './components/ComparisonSection';
import ArticlePreview from './components/ArticlePreview';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import FooterSection from './components/FooterSection';

export default function Home() {
  return (
    <main>
      <Navbar />
      <HeroSection />
      <TrustSection />
      <CategoryGrid />
      <ComparisonSection />
      <ArticlePreview />
      <FAQSection />
      <CTASection />
      <FooterSection />
    </main>
  );
}